<template>
  <b-row class="mt-2">
    <b-col cols="12" class="mt-3">
      <label>Buscar produto</label>
    </b-col>
    <b-col cols="9">
      <input 
        type="text"
        class="form-control" 
        v-model="searchProduct" 
        @keyup.enter="search()"
        placeholder="Nome produto, cód. barras ou marca..."
      >
    </b-col>
    <b-col cols="">
      <b-button
        variant="success"
        @click="search()"
      >Pesquisar</b-button>
      <b-button
      class="ml-4"
        variant="warning"
        @click="clean()"
      >Limpar</b-button>
    </b-col>
    
    <b-col cols="12" class="mt-5">
      <b-table
        striped
        outlined
        hover
        responsive
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
        empty-text="Nenhum produto encontrado"
      >
      <template #cell(photo)="data">
        <img
          :src="linkFotos(data.item.origem) + data.item.photo"
          :alt="data.item.product"
          style="width: 50px;"
        />
      </template>

      <template #cell(priceSalesFormat1)="data">
        <span>{{ formatNumber(data.item.priceSalesFormat1) }}</span>
      </template>

      <template #cell(taxRate)="data">
        <span>{{ data.item.taxRate }}%</span>
      </template>

      <template #cell(costPrice)="data">
        <span>{{ formatNumber(data.item.costPrice) }}</span>
      </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'ProductPartnerComponent',
  emits: ['getProduct', 'search', 'clean'],
  props: {
    table: {
      type: Object,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searchProduct: '',
    };
  },
  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },
  methods: {
    search() {
      this.$emit('search', this.searchProduct);
    },
    clean(){
      this.searchProduct = '';
      this.$emit('clean');
    },
    get() {
    this.$emit('getProduct')
    },
    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },
    linkFotos(origem) {
      if(origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },
  },
};
</script>
